import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import "../SanmarImages.css";

function SanmarImages({ inputNumber, color }) {
  const [mediaData, setMediaData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const parseXML = (xml) => {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xml, "text/xml");

    return [...xmlDoc.getElementsByTagName("ns2:MediaContent")]
      .map((item) => ({
        productId: item.getElementsByTagName("productId")[0]?.textContent,
        partId: item.getElementsByTagName("partId")[0]?.textContent,
        url: item.getElementsByTagName("ns2:url")[0]?.textContent,
        mediaType: item.getElementsByTagName("mediaType")[0]?.textContent,
        classTypeName: item.getElementsByTagName("ns2:classTypeName")[0]?.textContent,
        color: item.getElementsByTagName("ns2:color")[0]?.textContent || "Unknown",
      }))
      .filter((media) =>
        !["primary", "swatch", "custom", "rear", "front"].includes(
          media.classTypeName?.toLowerCase()
        )
      );
  };

  useEffect(() => {
    const fetchMedia = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch(
          "https://api-shipping-28612190fdf4.herokuapp.com/sanmarImages",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ lpn: inputNumber }),
          }
        );

        if (!response.ok) throw new Error("Failed to fetch media content");

        const textData = await response.text();
        const jsonData = parseXML(textData);

        const filteredData = jsonData; // Add color filtering if needed
        setMediaData(filteredData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (inputNumber) {
      fetchMedia();
    }
  }, [inputNumber, color]);

  return (
    <div style={{ marginBottom: mediaData.length > 0 ? "1rem" : 0 }}>
      {/* {loading && <p className="loading-text">Loading media...</p>} */}
      {/* {error && <p className="error-text">{error}</p>} */}

      {mediaData.length === 0 && (
        <div
          id="empty"
          style={{ height: 0, margin: 0, padding: 0, display: "none" }}
        />
      )}

      {mediaData.length > 0 && (
        <div className="container22">
          <Swiper
            spaceBetween={10}
            slidesPerView={1}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            modules={[Autoplay]}
            className="swiper-container"
          >
            {mediaData.map((image, index) => (
              <SwiperSlide key={index} className="slide circle-container">
                <img
                  src={image.url}
                  alt={image.classTypeName}
                  className="slide-image fit-image"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </div>
    
  );
}

export default SanmarImages;
